var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"navbar-list",attrs:{"nav":"","dense":""}},_vm._l((_vm.routes),function(route,i){return (route.show)?_c('navbar-list-item',{key:i,attrs:{"route":route,"level":1}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }